var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnExp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.33 16.85V7.64H10.08V16.85H11.33ZM9.45 7.8H8.22V11.13H7.17V12.2H8.22V16.44H9.45V7.8ZM6.29 10.44V10.25H7.7V9.19H6.29V7.95H5.04V9.19H3.6V10.25H5.04V10.44C5.04 11.86 4.57 13.37 3.26 14.14L4 15.13C4.84 14.65 5.37 13.83 5.68 12.87C6.01 13.75 6.54 14.48 7.35 14.91L8.06 13.93C6.76 13.24 6.29 11.83 6.29 10.44ZM12.1492 9.49H17.5392V8.46H15.4992V7.58H14.1792V8.46H12.1492V9.49ZM19.8292 13.21V7.65H18.5092V10.34H17.3592V11.41H18.5092V13.21H19.8292ZM17.0592 11.45C17.0592 10.46 16.1392 9.8 14.8492 9.8C13.5592 9.8 12.6392 10.46 12.6392 11.45C12.6392 12.44 13.5592 13.11 14.8492 13.11C16.1392 13.11 17.0592 12.44 17.0592 11.45ZM13.8992 11.45C13.8992 11.01 14.2892 10.77 14.8492 10.77C15.4092 10.77 15.7992 11.01 15.7992 11.45C15.7992 11.9 15.4092 12.14 14.8492 12.14C14.2892 12.14 13.8992 11.9 13.8992 11.45ZM19.8292 13.6H13.6992V16.75H19.8292V13.6ZM18.5392 15.72H14.9992V14.64H18.5392V15.72Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnExp);
export default __webpack_public_path__ + "static/media/btnExp.4f21b0e08135e66cfcbb59ca164a3f2f.svg";
export { ForwardRef as ReactComponent };